export default {
  最多填写10个纯数字: 'Within 10 digits',
  '纯数字,最多填写3位数字': 'Within 3 digits',
  标签只可以输出六个字以内: 'Each tag should be within 6 characters',
  自定义标签最多20个: 'You can add 20 tags at most',
  请输入手机号码: 'Please enter phone number',
  加入成功: 'Application is successful, please wait for enterprise review',
  公司名重复: 'Company name already exists',
  '图片格式为JPG/PNG,分辨率1920*430,大小不能超过10M':
    'JPG/PNG formats are accepted. Image resolution: 1920*430. Maximum file size: 10M',
  '图片格式为JPG/PNG,分辨率800*500,大小不能超过5M':
    'JPG/PNG formats are accepted. Image resolution: 800*500. Maximum file size: 5M',
  '图片格式为JPG/PNG,分辨率480*270,大小不能超过5M':
    'JPG/PNG formats are accepted. Image resolution: 480*270. Maximum file size: 5M',
}
